/** jQuery JavaScript for signalr **/
(function (signalr, $) {

    signalr.baseUrl;
    signalr.connection;
    signalr.accessToken;
    signalr.initialEvents = [];

    /**
     * Initializes the signalr
     * */
    signalr.init = function (baseUrl) {
        signalr.baseUrl = baseUrl;

        signalr.connection = new signalR.HubConnectionBuilder()
            .withUrl(signalr.baseUrl)
            .configureLogging(signalR.LogLevel.Information)
            .build();

        signalr.bindSignalrOnCloseEvent();
        signalr.addToGroup();

        signalr.initializeConnection();
    }

    /**
     * Initializes the connection of signalr
     **/
    signalr.initializeConnection = function () {
        try {
            signalr.connection.start().then(() => {
                for (let i = 0; i < signalr.initialEvents.length; i++)
                    signalr.initialEvents[i]();
            });
        } catch (err) {
            console.log(err);
            setTimeout(signalr.initializeConnection, 5000);
        }
    }

    /**
     *  Bind the signalr close event
     **/
    signalr.bindSignalrOnCloseEvent = function () {
        signalr.connection.onclose(async () => {
            setTimeout(function () {
                // Reinitialize with initial events
                signalr.initializeConnection();
            }, 5000);
        });

    }

    /**
     * Get the connection id
     **/
    signalr.getConnectionId = function () {
        return signalr.connection.state === signalR.HubConnectionState.Connected ?
            signalr.connection.connectionId : undefined;
    }

    /**
     * Add the client to group
     * @param {any} groupName
     **/
    signalr.addToGroup = function (groupName) {

        var func = () => { signalr.connection.invoke("addToGroup", groupName) };
        // Register the register to the initial events
        signalr.initialEvents.push(func);

        if (signalr.connection.hub && signalr.connection.hub.state === $.signalR.connectionState.connected) {
            // Execute directly, the connection already exists.
            func();
        }
    }

    /**
     * Remove the client from a group
     * @param {any} groupName
     **/
    signalr.removeFromGroup = function (groupName) {
        if (signalr.connection.hub && signalr.connection.hub.state === $.signalR.connectionState.connected) {
            // Only remove when connected
            signalr.connection.invoke("removeFromGroup", groupName);
        }
    }


}(window.signalr = window.signalr || {}, jQuery));
